import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export const useDatasetAssistant = (): boolean => {
  const user = useUser();
  return useFliptBoolean("dataset-chat-agent", false, user?.email);
};

export default useDatasetAssistant;
